import { tr } from 'mmfintech-commons'
import { ViewAllButton } from '@components/ViewAllButton'

import './DashboardBanner.scss'

type DashboardBannerProps = {
  image?: string
  heading?: string
  title?: string
  description?: string
  redirect?: string | (() => void)
  buttonLabel?: string
}

export const DashboardBanner = (props: DashboardBannerProps) => {
  const { heading, title, description, redirect, image, buttonLabel } = props

  return (
    <div className='dashboard-banner-wrapper'>
      <div className='dashboard-banner-heading'>
        <div className='dashboard-banner-header'>{heading}</div>
        <ViewAllButton label={buttonLabel} redirect={redirect} />
      </div>
      <div className='dashboard-banner-main'>
        <img
          src={image}
          alt={tr('FRONTEND.DASHBOARD.BANNER_IMAGE', '{{heading}} banner image', { heading })}
          className='dashboard-banner-image'
        />
        <div className='dashboard-banner-content'>
          <div className='dashboard-banner-title'>{title}</div>
          <div className='dashboard-banner-description'>{description}</div>
        </div>
      </div>
    </div>
  )
}
